import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    contrast: localStorage.getItem("highContrast") == "true",
    facilities: localStorage.getItem("facilities") == "true",
    devGpsDebugOverlay: localStorage.getItem("devGpsDebugOverlay") == "true"
};

const settingsSlice = createSlice({
    name: "settingsSlice",
    initialState,
    reducers: {
        setContrast: (state, action) => {
            localStorage.setItem("highContrast", action.payload.toString());
            state.contrast = action.payload;
        },
        setFacilities: (state, action) => {
            localStorage.setItem("facilities", action.payload.toString());
            state.facilities = action.payload;
        },
        setDevGpsDebugOverlay: (state, action) => {
            localStorage.setItem("devGpsDebugOverlay", action.payload.toString());
            state.devGpsDebugOverlay = action.payload;
        }
    }
});

export const {setContrast, setFacilities, setDevGpsDebugOverlay} = settingsSlice.actions;

export const getContrast = (state: any) => state.settings.contrast;
export const getFacilities = (state: any) => state.settings.facilities;
export const getDevGpsDebugOverlay = (state: any) => state.settings.devGpsDebugOverlay;

export default settingsSlice.reducer;
